import React, { useMemo } from 'react';

import { format } from 'date-fns';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import CustomHeader from 'CommonComponents/DatePickerCustomHeader';

const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

function DatePickerField(props) {
    const minMaxDatesConditionalPops = useMemo(() => {
        if (!props.min || !props.max) {
            return {};
        }

        return { minDate: new Date(props.min), maxDate: new Date(props.max) };
    }, [props.min, props.max]);

    return (
        <ConditionalWrapper condition={props.wrapped} wrapper={(children) => <div>{children}</div>}>
            <DatePicker
                renderCustomHeader={(headerProps) => CustomHeader({ ...headerProps, min: props.min, max: props.max })}
                id={props.id}
                className={props.className}
                wrapperClassName={props.wrapperClassName}
                selected={(props.value && new Date(props.value)) || null}
                onChange={(val) => {
                    if (val && props.valueFormat && typeof props.valueFormat === 'string') {
                        props.onChange(props.name, format(new Date(val), props.valueFormat));
                    } else {
                        props.onChange(props.name, val);
                    }
                }}
                onCalendarOpen={() => {
                    if (props.onCalendarOpen) {
                        props.onCalendarOpen();
                    }
                }}
                onCalendarClose={() => {
                    if (props.onCalendarClose) {
                        props.onCalendarClose();
                    }
                }}
                dateFormat={props.dateFormat || 'd-M-yyyy'}
                autoComplete={'off'}
                autoFocus={props.autoFocus}
                disabled={props.disabled}
                showMonthYearPicker={props.showMonthYearPicker}
                customInput={props.customInput}
                onFocus={props.onFocus}
                preventOpenOnFocus={props.preventOpenOnFocus}
                portalId={props.portalId}
                fixedHeight={props.fixedHeight}
                closeOnScroll={props.closeOnScroll}
                {...minMaxDatesConditionalPops}
            />
        </ConditionalWrapper>
    );
}

export default DatePickerField;
